<main class="table-page table-page--fill" dir="rtl">
  <header class="header"><div class="title-row">
    <button class="back" type="button" aria-label="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
    <div class="title-block"><h1 class="title">{{ definition.title }}</h1><span class="muted">{{ subtitle | faNum }}</span></div>
  </div></header>
  <section class="card" app-route-analysis-table [rows]="rows" [columns]="columns" [title]="definition.title" [subtitle]="subtitle"
    [fileName]="definition.fileName" [tableKey]="tableKey" [exportTotals]="true" [loading]="loading" [hasError]="hasError" [errorMessage]="errorMessage"
    [hasRequestedData]="true" (retry)="loadReport()"></section>
</main>
